import { KEYS as k } from 'server/util/inventory_config';
import { addOneMonth } from 'shared/util/date';

export function processFilters(filterValues, buildings) {
  const [minCapacity, maxCapacity, capacity] = parseCapacity(filterValues.capacity);
  const [date, maxDate] = dates(filterValues.date);
  const availableBuildings = [];
  const unavailableBuildings = [];

  buildings.forEach(building => {
    const shouldFilterPrivateOffice = !filterValues.workspace || filterValues.workspace === 'privateOffice';
    if (shouldFilterPrivateOffice) {
      const isCapacityNotARange = capacity === minCapacity;
      if (isCapacityNotARange && hasOfficeAvailable(building, minCapacity, date)) {
        availableBuildings.push(building);
        return;
      }

      for (let i = Number(minCapacity); i <= maxCapacity; i++) {
        if (hasOfficeAvailable(building, i, maxDate)) {
          const imperfectDate = calculateImperfectDate(building, i, date);
          availableBuildings.push({ ...building, imperfectCapacity: i, imperfectDate });
          return;
        }
      }
    }

    const shouldFilterDedicatedDesks = !filterValues.workspace || filterValues.workspace === 'dedicatedDesk';
    if (shouldFilterDedicatedDesks && hasDedicatedDeskAvailable(building, minCapacity, date)) {
      availableBuildings.push(building);
      return;
    }

    const shouldFilterHotDesk = !filterValues.workspace || filterValues.workspace === 'hotDesk';
    if (shouldFilterHotDesk && hasHotDeskAvailable(building, minCapacity)) {
      availableBuildings.push(building);
      return;
    }

    unavailableBuildings.push(building);
  });

  return [availableBuildings, unavailableBuildings];
}

function parseCapacity(capacity = '') {
  const capacityArray = capacity.split('-');
  const [minCapacity] = capacityArray;
  const maxCapacity = capacityArray[1] || calculateMaxCapacity(minCapacity);
  return [minCapacity, maxCapacity, capacity];
}

function dates(date) {
  const maxDate = addOneMonth(date);
  return [date, maxDate];
}

// Formula is: min_capacity(user input) + 25 %, rounded up to nearest even integer
function calculateMaxCapacity(capacity) {
  let max = Math.ceil(capacity * 1.25);
  if (max % 2 !== 0) {
    max += 1;
  }
  return max;
}

function hasDedicatedDeskAvailable(building, capacity, date) {
  return capacity === '1' && building[k.dedicated_desk_date] <= date;
}

function hasHotDeskAvailable(building, capacity) {
  return capacity === '1' && building[k.all_access_price];
}

function hasOfficeAvailable(building, capacity, date) {
  return building[k[`office_${capacity}_date`]] <= date;
}

function calculateImperfectDate(building, capacity, date) {
  return building[k[`office_${capacity}_date`]] < date ? date : building[k[`office_${capacity}_date`]];
}
